import { TProduct } from '@/screens/Product/page/types/types'

export const getRemoveFromCart = (
	product: Partial<TProduct>,
	category: string,
	location: string
): Record<string, any> | null => {
	return {
		event: 'remove_from_cart',
		ecommerce: {
			currencyCode: 'RUB',
			remove: {
				products: [
					{
						id: product.KOD,
						name: product.TITLE,
						brand: product.PROPERTIES?.osnovnye_parametry?.GROUP_PROPERTIES?.PROIZVODITEL?.values[0],
						category: category || ``,
						quantity: 1,
						list: location || '',
						position: 1
					}
				]
			}
		}
	}
}
